// @ts-nocheck
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Spin,
  Tooltip,
} from 'antd';
import React, { useEffect, useState } from 'react';
import Password from '../../../../components/general/password';
import { useQuery } from '@tanstack/react-query';
import { CreateUser, Customer, User, get } from '../../../../api';
import { QuestionCircleOutlined } from '@ant-design/icons';

type UserFormProps = {
  type: string;
  id?: number | null;
  add: (v: CreateUser) => void;
  update: (v: User) => void;
};

const UserForm: React.FC<UserFormProps> = (props) => {
  const { type, id, add, update } = props;
  const [form] = Form.useForm();
  const [customers, setCustomers] = useState([]);
  const [customerSelected, setCustomerSelected] = useState(false);
  const roleOptions = [
    { label: 'Admin', value: 1 },
    { label: 'Financiero', value: 2 },
    { label: 'Cliente', value: 3 },
    { label: 'Ventas', value: 4 },
  ];
  //ENDPOINTS
  const { isLoading: isLoadingUser, data } = useQuery<User>([type], () =>
    get<User>('/users/' + id).then((e) => e.data)
  );
  const { isLoading: isLoadingCustomers, data: customersget } = useQuery<
    Customer[]
  >(['cliente'], () => get<Customer[]>('/customers/').then((e) => e.data));

  useEffect(() => {
    if (customersget) {
      const customersOrdenados = [...customersget];
      customersOrdenados.sort((a, b) =>
        a.company_name.localeCompare(b.company_name)
      );
      setCustomers(customersOrdenados);
    }
  }, [customersget]);

  useEffect(() => {
    if (data && type !== 'add' && id && !isLoadingUser) {
      form.setFieldsValue({
        email: data?.email,
        username: data?.username,
        role: data?.role,
        status: data?.status,
        customer_id: data?.customer_id !== 0 ? data?.customer_id : null,
        first_name: data?.first_name,
        last_name: data?.last_name,
        middle_name: data?.middle_name,
        phone: data?.phone,
      });
    }
  }, [form, data, id, type, isLoadingUser]);

  //OCULTAR SELECT DE CLIENTES
  useEffect(() => {
    if (data && data?.customer_id !== null && data?.customer_id !== 0) {
      setCustomerSelected(true);
    }
  }, [data]);

  const addUserFunction = async (values: any) => {
    if (type === 'add') {
      // AGREGAR USUARIO
      let userRequest: CreateUser = {
        email: values.email,
        password: values.password,
        role: values.role,
        username: values.username,
        first_name: values.first_name,
        last_name: values.last_name,
        middle_name: values.middle_name,
        phone: values.phone,
        status: values.status,
        customer_id: values.customer_id ? values.customer_id : 0,
      };
      add(userRequest);
    } else {
      // EDITAR USUARIO
      values['id'] = id;
      update(values);
    }
  };

  return (
    <Spin
      spinning={isLoadingUser || isLoadingCustomers}
      tip={<p>Cargando...</p>}
    >
      <Form
        name="add-promo"
        layout="vertical"
        form={form}
        onFinish={addUserFunction}
      >
        <Divider />
        <Row style={{ display: 'flex', justifyContent: 'center' }}>
          <Col xs={20}>
            <Form.Item
              label="Usuario:"
              name="username"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese un nombre',
                },
              ]}
            >
              <Input
                placeholder="Ingresa información"
                disabled={type === 'watch'}
              />
            </Form.Item>
            <Form.Item
              label="Correo electrónico:"
              name="email"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese un email',
                },
              ]}
            >
              <Input
                type="email"
                placeholder="Ingresa información"
                disabled={type !== 'add'}
              />
            </Form.Item>
            <Form.Item
              label="Usuario estatus:"
              name="status"
              valuePropName="checked"
            >
              <Checkbox disabled={type === 'watch'}>Activo</Checkbox>
            </Form.Item>

            {type === 'add' && <Password type="adduser" />}
            <Form.Item
              label="Primer nombre:"
              name="first_name"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese un nombre',
                },
              ]}
            >
              <Input
                disabled={type === 'watch'}
                placeholder="Ingresa información"
              />
            </Form.Item>
            <Form.Item
              label="Segundo nombre:"
              name="middle_name"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese un nombre',
                },
              ]}
            >
              <Input
                disabled={type === 'watch'}
                placeholder="Ingresa información"
              />
            </Form.Item>
            <Form.Item
              label="Apellidos:"
              name="last_name"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese apellidos',
                },
              ]}
            >
              <Input
                disabled={type === 'watch'}
                placeholder="Ingresa información"
              />
            </Form.Item>
            <Form.Item
              label={
                <span>
                  Teléfono:&nbsp;
                  <Tooltip title="El número telefónico debe contener 10 dígitos">
                    <QuestionCircleOutlined />
                  </Tooltip>
                </span>
              }
              name="phone"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingresa número telefónico',
                },
                ({ getFieldValue }) => ({
                  validator(rule, value) {
                    if (!value || value.toString().length === 10) {
                      return Promise.resolve();
                    }

                    return Promise.reject(
                      'Por favor ingresa número telefónico a 10 dígitos'
                    );
                  },
                }),
              ]}
            >
              <Input
                disabled={type === 'watch'}
                placeholder="Ingresa información"
              />
            </Form.Item>
            <Form.Item
              label="Cliente:"
              name="customer_id"
              hidden={customerSelected === false}
              rules={[
                {
                  required: customerSelected,
                  message: 'Por favor seleccione un cliente',
                },
              ]}
            >
              <Select
                disabled={type === 'watch'}
                placeholder="Selecciona una opción"
                optionFilterProp="children"
                filterOption={(input, option) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >=
                  0
                }
                showSearch
              >
                {customers?.map((s: any) => (
                  <Select.Option key={s.id} value={s.id}>
                    {s.company_name}
                  </Select.Option>
                ))}
              </Select>
            </Form.Item>

            <Form.Item
              label="Rol de usuario:"
              name="role"
              rules={[
                {
                  required: true,
                  message: 'Por favor ingrese un rol',
                },
              ]}
            >
              <Radio.Group
                disabled={type === 'watch'}
                options={roleOptions}
                // initialValues={[1]}
                onChange={(e) =>
                  e.target.value === 3
                    ? setCustomerSelected(true)
                    : setCustomerSelected(false)
                }
              ></Radio.Group>
            </Form.Item>
            <Row justify="end">
              <Form.Item>
                <Button
                  htmlType="submit"
                  className="btn-add"
                  disabled={type === 'watch' || isLoadingUser}
                >
                  Guardar
                </Button>
              </Form.Item>
            </Row>
          </Col>
        </Row>
      </Form>
    </Spin>
  );
};

export default UserForm;
